<template>
  <div>
    <ul class="tab clearfix">
      <li
        v-for="(item,index) in tab"
        :class="{'active':tabNum == index}"
        @click="onTab(index)"
        :key="item.title"
      >{{item.title}}</li>
    </ul>
    <div class="content">
      <ul
        class="activity-list"
        v-if="activityList.length>0"
        v-infinite-scroll="getMyActivityList"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="20"
      >
        <li :class="{'border':tabNum != 0}" v-for="(item) in activityList" :key="item.ID">
          <router-link :to="{name:'activity-detail',params: {id: item.ActivityID}}">
            <div class="img">
              <img
                :src="item.TitleImagePath ?item.TitleImagePath +'?x-oss-process=image/resize,m_fill,h_200,w_290':defaultImg"
                :onerror="defaultImg"
                alt
              >
            </div>
            <div class="main-content">
              <h5>{{item.Title}}</h5>
              <span>时间：{{item.ActivityStartTimeTXT}}</span>
              <span v-if="tabNum == 1">地点：{{item.ProvinceName}}{{item.CityName}}——{{item.Place}}</span>
              <span v-else>地点：{{item.ProvinceName}}{{item.CityName}}</span>
            </div>
          </router-link>
          <!-- <div class="btn-main label">大赛</div> -->
          <div class="main-footer clearfix" v-if="tabNum != 0">
            <div class="btns" v-if="tabNum == 1">
              <!-- <button @click="cancelApply(item.ID,index)">取消报名</button> -->
              <button>
                <router-link :to="{name:'my-ticket',query: {id: item.ID}}">查看电子票</router-link>
              </button>
            </div>
            <div class="cause" v-if="tabNum == 2">
              <p>
                原因：
                <span>{{item.ApplyReturnReason}}</span>
              </p>
            </div>
            <!-- <div class="btns" v-if="tabNum == 2">
              <button>重新报名</button>
            </div>-->
          </div>
        </li>
      </ul>
      <div class="status-hint" v-show="pageHint">{{pageHint}}</div>
      <empty v-if="isEmpty"></empty>
    </div>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
import empty from '@/views/statePage/empty.vue'
import footerLogo from '@/components/footerLogo.vue'
export default {
  components: {
    'footer-logo': footerLogo,
    empty
  },
  data() {
    return {
      tabNum: 0,
      tab: [
        {
          title: '审核中'
        },
        {
          title: '已通过'
        },
        {
          title: '未通过'
        }
      ],
      loading: false,
      pageHint: '',
      isEmpty: false,
      params: {
        status: 1,
        pageIndex: 1,
        pageSize: 10
      },
      totalPage: -1,
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"',
      activityList: [],
      isLoading: true
    }
  },
  created() {
    this.getMyActivityList()
  },
  methods: {
    onTab(index) {
      if (this.tabNum != index) {
        this.tabNum = index
        this.params.status = index + 1
        this.params.pageIndex = 1
        this.totalPage = -1
        this.activityList = []
        this.getMyActivityList()
      }
    },
    getMyActivityList() {
      if (this.totalPage > -1 && this.params.pageIndex > this.totalPage) {
        this.loading = false
      } else {
        this.loading = true
        this.pageHint = '加载中...'
        var _this = this
        this.$fetch('/api/Activity/MyList', this.params).then(result => {
          this.isLoading = false
          this.loading = false
          _this.totalPage = result.PageCount
          if (this.params.pageIndex >= this.totalPage) {
            this.pageHint = '没有更多了'
          } else {
            this.pageHint = '上拉加載更多'
          }

          if (result.Items && result.Items.length > 0) {
            this.activityList = this.activityList.concat(result.Items)
            this.isEmpty = false
          } else {
            this.isEmpty = true
            this.pageHint = ''
          }
          this.params.pageIndex++
        })
      }
    },
    cancelApply(applyId, index) {
      let _this = this
      this.$dialog.confirm({
        title: '取消报名',
        mes: '确定要取消报名？',
        opts: () => {
          this.$post('/api/Activity/CancelApply', {
            id: applyId
          })
            .then(result => {
              this.$dialog.toast({
                mes: '取消报名成功',
                timeout: 1500
              })
              _this.activityList.splice(index, 1)
              if (_this.activityList.length == 0) {
                this.isEmpty = true
                this.pageHint = ''
              }
            })
            .catch(result => {
              this.$dialog.toast({
                mes: result.Error.Message,
                timeout: 2500
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#success {
  background: #f7f7f7 !important;
}

.tab {
  width: 100%;
  height: 100 / @rem-size;
  background: #fff;
  border-bottom: 20 / @rem-size solid #f7f7f7;
  box-sizing: content-box;

  li {
    width: 33.33333%;
    height: 100%;
    font-size: 32 / @rem-size;
    line-height: 100 / @rem-size;
    text-align: center;
    position: relative;
    float: left;

    &.active {
      color: #005fd5;

      &::after {
        content: '';
        display: block;
        width: 88 / @rem-size;
        height: 3 / @rem-size;
        background: #005fd5;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }
}

.activity-list {
  padding-top: 25 / @rem-size;
  background: #fff;

  li {
    margin-top: 25 / @rem-size;
    padding: 0 24 / @rem-size;
    position: relative;

    a {
      display: flex;
      padding-bottom: 25 / @rem-size;
      border-bottom: 1px solid #e6e6e6;
    }

    &.border {
      border-bottom: 20 / @rem-size solid #f7f7f7;

      &:last-child {
        a {
          border-bottom: 1px solid #e6e6e6;
        }
      }
    }

    .label {
      width: 80 / @rem-size;
      height: 40 / @rem-size;
      font-size: 24 / @rem-size;
      text-align: center;
      line-height: 40 / @rem-size;
      position: absolute;
      top: 16 / @rem-size;
      left: 24 / @rem-size;
      margin: auto;
    }

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      a {
        border: none;
      }
    }

    .img {
      width: 200 / @rem-size;
      height: 132 / @rem-size;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .main-content {
      flex: 1;
      margin-left: 22 / @rem-size;

      h5 {
        font-size: 0.3rem;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 4.9rem;
        font-weight: 500;
      }

      span {
        display: block;
        margin-top: 10 / @rem-size;
        color: #999;
        font-size: 28 / @rem-size;
      }
    }
  }
}

.main-footer {
  width: 100%;
  min-height: 112 / @rem-size;
  background: #fff;

  .btns {
    float: right;
    padding-top: 22 / @rem-size;

    button {
      width: 180 / @rem-size;
      height: 64 / @rem-size;
      background: #fff;
      border-radius: 8 / @rem-size;
      border: 1px solid #e5e5e5;
      font-size: 28 / @rem-size;
      margin-left: 21 / @rem-size;

      a {
        display: inline !important;
        padding: 0 !important;
        border: 0 !important;
      }

      &:active {
        background: #fff - 10%;
      }
    }
  }
}

.cause {
  padding: 20 / @rem-size 0;

  p {
    width: 100%;
    height: auto;
    padding: 20 / @rem-size;
    background: #f7f7f7;
    font-size: 28 / @rem-size;

    span {
      color: #999;
    }
  }
}
</style>
